import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowLeft,
  faBars,
  faBook,
  faBrain,
  faCaretDown,
  faCaretUp,
  faCheckCircle,
  faCog,
  faEdit,
  faEllipsisV,
  faExclamationTriangle,
  faLayerGroup,
  faPencilAlt,
  faPlus,
  faQuestionCircle,
  faRedo,
  faStopwatch,
  faTag,
  faTags,
  faTimes,
  faTimesCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import {
  faLightbulb,
  faStar,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faArrowLeft,
  faBars,
  faBook,
  faBrain,
  faCaretDown,
  faCaretUp,
  faCheckCircle,
  faCog,
  faEdit,
  faEllipsisV,
  faExclamationTriangle,
  faLayerGroup,
  faLightbulb,
  faQuestionCircle,
  faPencilAlt,
  faPlus,
  faRedo,
  faStopwatch,
  faTag,
  faTags,
  faTimes,
  faTimesCircle,
  faTrash,
  faStar,
);